import styled from 'styled-components';

export const TermsOfServiceContainer = styled.div`
  background: #f5f5f5;
  color: #000;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 100px 10px 10px 75px;
  width: flex;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    108deg,
    rgba(204, 143, 45, 1) 0%,
    rgb(0 0 0) 100%
  );

  @media screen and (max-width: 490px){
    position: unset;
    padding: 100px 10px 10px 10px;
  }
`;

export const TermsWrapper = styled.div`
  display:flex;  
  flex-direction: column;
  width: 80%;
  background: #f5f5f5;
  align-items:center;
  justify-content: center;

  @media screen and (max-width: 490px){
    align-items: start;
  }
`;

export const TopLine = styled.div`
  margin-top: 24px;
  color: #black;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;

  @media screen and (max-width: 490px){
    font-size: 16px;
    padding-left: 12px;
    align-items: left;
  }

`;

export const SectionText = styled.p`
  width: 70%;
  border: black;
  padding: 12px;
  font-size: 16px;
  line-height: 24px;
  color: black;
  
  @media screen and (max-width: 490px){
    width: 100%;
  }
`;
